import { handleResponse, handleError } from "./apiUtils";
const baseUrl = process.env.REACT_APP_API_SERVER_URL + "/api/profile";

export function getUserProfile(accessToken) {
  console.log("get userprofile in userapi");
  return fetch(baseUrl, {
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + accessToken
    }
  })
    .then(handleResponse)
    .catch(handleError);
}

export function saveUser(accessToken, user) {
  console.log(JSON.stringify(user));
  return fetch(baseUrl, {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + accessToken
    },
    body: JSON.stringify(user)
  })
    .then(handleResponse)
    .catch(handleError);
}

export function deleteUser(accessToken) {
  return fetch(baseUrl, {
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + accessToken
    }
  })
    .then(handleResponse)
    .catch(handleError);
}

export function report(accessToken, eventId, profileId, reason) {
  console.log(eventId, profileId, reason);
  return fetch(baseUrl + "/report", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + accessToken
    },
    body: JSON.stringify({
      eventid: eventId,
      userid: profileId,
      reason: reason
    })
  })
    .then(handleResponse)
    .catch(handleError);
}
